import { useState, useEffect } from "react";
import useRouteParams from "./useRouteParams";

// Factory function to initialize and update filter states
export const  useFilterState = (list, searchParamsKey) => {
  const { searchParams } = useRouteParams();
  const initializeChecked = () => {
      const paramValues = searchParams[searchParamsKey] ? searchParams[searchParamsKey].split(",") : [];
      return list.reduce((acc, item) => {
        acc[item.id] = paramValues.includes(item.id.toLowerCase());
        return acc;
      }, {});
    };
  
    const [state, setState] = useState(initializeChecked);
  
    useEffect(() => {
      setState(initializeChecked()); // Re-initialize when searchParams change
    }, [searchParams[searchParamsKey]]);
  
    return [state, setState];
  };